module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"th":{"chart.name":"จำนวน Active Ticket ตาม Lot","chart.summary":"มี Ticket ค้างอยู่ทั้งหมด {total} @:common.ticket.unit"}}')
  delete Component.options._Ctor
}
